import { useId } from 'react';

export default function ApplicationOptionSelector({
  id,
  label,
  labelAside = null,
  value,
  disabled = false,
  options = [],
  onChange,
  note = null,
  className = ''
}) {
  const generatedId = useId();
  const selectId = id || `av-app-option-selector-${generatedId}`;

  if (!options.length) {
    return null;
  }

  const classes = [
    'av-app-option-selector',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="av-app-option-selector__label-row">
        <label
          className="av-app-option-selector__label"
          htmlFor={selectId}
        >
          {label}
        </label>
        {labelAside ? (
          <div className="av-app-option-selector__label-aside">
            {labelAside}
          </div>
        ) : null}
      </div>

      <select
        className="av-app-option-selector__control"
        id={selectId}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {note}
    </div>
  );
}
